import {gql} from "@irati/utils/gql"

const fragment = gql`
  fragment TenantOnboardingStep on TenantOnboardingStep {
    stepId
    state
    selection
    metadata {
      updatedBy
      updatedAt
    }
  }
`

export default fragment
